import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  useRouteError,
} from 'react-router-dom';
import { AxiomProvider } from '@optiaxiom/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { loadOptiWebComponents } from './utils/loadOptiWebComponents.ts';
import { SentryErrorBoundary } from './utils/sentry.ts';
import App from './App.tsx';

import './styles/globals.css.ts';

const queryClient = new QueryClient();

export const RethrowError = () => {
  throw useRouteError();
};

const router = createBrowserRouter(
  createRoutesFromElements(<Route path="*" element={<App />} errorElement={<RethrowError />} />)
);

loadOptiWebComponents().catch(console.error);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}
createRoot(rootElement).render(
  <StrictMode>
    <SentryErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AxiomProvider>
          <RouterProvider router={router} />
        </AxiomProvider>
      </QueryClientProvider>
    </SentryErrorBoundary>
  </StrictMode>
);
